'use strict';

angular.module('app').run(function (Language) {}) // jshint ignore:line

.factory('Language', function (DS) {
    return DS.defineResource({
        name: 'Language',
        endpoint: 'languages',
        upsert: true
    });
});
